// <s-random-picks> shows a fresh random selection of its server-rendered product cards on every
// page view. Children marked [data-random-pick] are the pool; data-count of them stay visible,
// chosen at random each load. Without JavaScript the first data-count cards (rendered visible) stay.
class RandomPicks extends HTMLElement {
  connectedCallback() {
    const items = [...this.querySelectorAll('[data-random-pick]')];
    const count = Math.min(Number(this.dataset.count) || 4, items.length);
    if (items.length <= count) return;

    const order = items.map((_, index) => index);
    for (let i = order.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [order[i], order[j]] = [order[j], order[i]];
    }

    const chosen = new Set(order.slice(0, count));
    const grid = items[0].parentElement;
    items.forEach((item, index) => {
      item.hidden = !chosen.has(index);
    });
    // Show the chosen cards in their shuffled order too, not catalog order.
    for (const index of order.slice(0, count)) grid.appendChild(items[index]);
  }
}

if (!customElements.get('s-random-picks')) customElements.define('s-random-picks', RandomPicks);
